import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const BusinessPolicyLiabilitySlips = Loadable(
  lazy(() =>
    import("./BusinessPolicyLiabilitySlips").then(
      ({ BusinessPolicyLiabilitySlipsWrapper }) => ({
        default: BusinessPolicyLiabilitySlipsWrapper,
      })
    )
  )
);

export const BusinessPolicyLiabilitySlipsRouter = [
  {
    path: "/business-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPolicyLiabilitySlips />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/business-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPolicyLiabilitySlips />
      </AuthorizedRoute>
    ),
  },
   {
              path: "/business-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/duplicate/:serialNumber",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <BusinessPolicyLiabilitySlips isDuplicate />
                </AuthorizedRoute>
              ),
            },
];
